import BusinessIcon from '@mui/icons-material/Business';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import { Card, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import {
  a11yProps,
  CustomTabPanel,
} from '../employees/components/tabs/EmployeeTabs';
import CompanyExpenses from './components/CompanyExpenses';

const AdminExpenses = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tab, id } = useParams();
  const [value, setValue] = React.useState(tab ? parseInt(tab) - 1 : 0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // Navigate with the correct 1-based index for the URL
    navigate(
      !!id
        ? `/admin/expense/${id}/${newValue + 1}`
        : `/admin/expense/create/${newValue + 1}`,
    );
  };

  return (
    <Card>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        aria-label="basic tabs example"
      >
        <Tab
          icon={<BusinessIcon />}
          label={t('expenses.companyExpenses')}
          {...a11yProps(0)}
        />
        <Tab
          icon={<Groups2OutlinedIcon />}
          onClick={() => navigate('/admin/team-contributions')}
          label={t('expenses.teamExpenses')}
          {...a11yProps(1)}
        />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <CompanyExpenses />
      </CustomTabPanel>
    </Card>
  );
};

export default AdminExpenses;
